import { AlertTriangle } from "lucide-react";

export default function ComingSoon({ title, description, testId }) {
  return (
    <div
      data-testid={testId}
      className="rounded-md border border-dashed border-zinc-800 bg-zinc-950 p-10 flex flex-col items-start gap-3"
    >
      <div className="inline-flex items-center gap-2 rounded-full border border-zinc-800 px-2.5 py-1 text-[10px] uppercase tracking-widest text-zinc-400 font-mono">
        <AlertTriangle className="h-3 w-3 text-amber-400" />
        No implementado aún
      </div>
      <h3 className="text-xl font-semibold text-white">{title}</h3>
      {description && (
        <p className="text-sm text-zinc-400 max-w-2xl">{description}</p>
      )}
    </div>
  );
}
